// src/utils/voterRegistrationUtils.js

/**
 * VoteAmerica's embed script reads `source` and the `utm_*` query params off
 * whatever page it runs in, then forwards them to the tool iframe. Those values
 * come back as their own columns in the VoteAmerica CSV export, which is how a
 * registration check gets tied back to the DJ who ran it.
 *
 * https://docs.voteamericaplus.org/software/tracking/
 */

// Identifies the hub as the traffic source across every entry point.
export const VOTER_REG_UTM_SOURCE = 'djs-portal';

// Which entry point sent the DJ to the tool. Both open the same in-app popup;
// these distinguish the popup we show them from the one they asked for.
export const VOTER_REG_MEDIUM_AUTO_POPUP = 'auto-popup';
export const VOTER_REG_MEDIUM_DASHBOARD_LINK = 'dashboard-link';

/**
 * Append DJ and election tracking params to a voter registration URL.
 *
 * Values are prefixed (`dj-`, `election-`) so the raw Quickbase record IDs stay
 * unambiguous in the export.
 *
 * @param {string} baseUrl - Registration URL, which may already carry query params
 * @param {Object} options
 * @param {string|number} [options.djRid] - Quickbase record ID of the DJ
 * @param {string|number} [options.electionRid] - Quickbase record ID of the election
 * @param {string} options.medium - Entry point that sent the DJ to the tool
 * @returns {string} The URL with tracking params applied
 */
export const buildVoterRegistrationUrl = (baseUrl, { djRid, electionRid, medium }) => {
  const url = new URL(baseUrl);

  url.searchParams.set('utm_source', VOTER_REG_UTM_SOURCE);
  url.searchParams.set('utm_medium', medium);

  if (djRid) {
    url.searchParams.set('utm_content', `dj-${djRid}`);
  }
  if (electionRid) {
    url.searchParams.set('utm_campaign', `election-${electionRid}`);
  }

  return url.toString();
};
